import React, { ReactElement } from 'react';

import {
    RefreshControl as RNRefreshControl,
    RefreshControlProps,
} from 'react-native';

import { whiteTransparent } from 'utils/colors';

export const RefreshControl = (props: RefreshControlProps): ReactElement => {
    return <RNRefreshControl tintColor={whiteTransparent(1)} {...props} />;
};
